import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import dayjs from 'dayjs';
import { Tabs } from 'antd';
import { H3_TITLE } from '@Apis/constants';
import UserActions from '@Actions/userActions';
import Helpers from '@Apis/helpers';
import PendingActions from '@Components/Home/HomeTabs/PendingActions';
import PurchaseDashboard from '@Components/Home/HomeTabs/PurchaseDashboard';
import InventoryDashboard from '@Components/Home/HomeTabs/InventoryDashboard';
import ProductionDashboard from '@Components/Home/HomeTabs/ProductionDashboard';
import SalesDashboard from '@Components/Home/HomeTabs/SalesDashboard';
import './style.scss';

const { TabPane } = Tabs;

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedInterval: 'this_month',
      startDateMomentEpoch: dayjs().startOf('month').valueOf(),
      endDateMomentEpoch: dayjs().endOf('month').valueOf(),
      currentTab: '/pending-actions',
      quickActions: [
        {
          key: '1',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
              1st menu item
            </a>
          ),
        },
        {
          key: '2',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.aliyun.com">
              2nd menu item
            </a>
          ),
        },
        {
          key: '3',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com">
              3rd menu item
            </a>
          ),
        },
      ],
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      return {
        ...state,
        currentTab: Helpers.getValueFromUrl('tab') || '/pending-actions',
        isUserReady: true,
      };
    }
    return state;
  }

  render() {
    const {
      user, history,
    } = this.props;
    const {
      startDateMomentEpoch, endDateMomentEpoch, selectedInterval, currentTab,
    } = this.state;
    return (
      <Fragment>
        <div className="doc-list__tabs-wrapper">
          <Tabs
            activeKey={currentTab}
            onChange={(key) => {
              this.setState({ currentTab: key });
              history.push(`?tab=${key}`);
            }}
            mode="horizontal"
          >
            <TabPane tab="Pending Actions" key="/pending-actions" />
            {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_DASHBOARD, Helpers.permissionTypes.READ, user) && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_DASHBOARD, Helpers.permissionTypes.CREATE, user) && <TabPane tab="Purchase Dashboard" key="/purchase-dashboard" />}
            {Helpers.getPermission(Helpers.permissionEntities.INVENTORY_DASHBOARD, Helpers.permissionTypes.READ, user) && Helpers.getPermission(Helpers.permissionEntities.INVENTORY_DASHBOARD, Helpers.permissionTypes.CREATE, user) && <TabPane tab="Inventory Dashboard" key="/inventory-dashboard" />}
            {Helpers.getPermission(Helpers.permissionEntities.PRODUCTION_DASHBOARD, Helpers.permissionTypes.READ, user) && Helpers.getPermission(Helpers.permissionEntities.PRODUCTION_DASHBOARD, Helpers.permissionTypes.CREATE, user) && <TabPane tab="Production Dashboard" key="/production-dashboard" />}
            {Helpers.getPermission(Helpers.permissionEntities.SALES_DASHBOARD, Helpers.permissionTypes.READ, user) && Helpers.getPermission(Helpers.permissionEntities.SALES_DASHBOARD, Helpers.permissionTypes.CREATE, user) && <TabPane tab="Sales Dashboard" key="/sales-dashboard" />}
          </Tabs>
          {currentTab === '/pending-actions' && <PendingActions />}
          {currentTab === '/purchase-dashboard' && <PurchaseDashboard />}
          {currentTab === '/inventory-dashboard' && <InventoryDashboard />}
          {currentTab === '/production-dashboard' && <ProductionDashboard />}
          {currentTab === '/sales-dashboard' && <SalesDashboard />}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
